// extracted by mini-css-extract-plugin
module.exports = {"h1":"HeaderLogo_h1__2BPh-","studioLogo":"HeaderLogo_studioLogo__1dtkB","hubLogo":"HeaderLogo_hubLogo__3RqFF","label":"HeaderLogo_label__23pmv"};